import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const PWC_LOGO = "/pwc-logo-secondary.png";

const navLinks = [
  { to: "/", label: "HOME" },
  { to: "/locker-room", label: "LOCKER ROOM" },
  { to: "/championships", label: "TITLES" },
  { to: "/shows", label: "SHOWS" },
  { to: "/dirt-sheets", label: "DIRT SHEETS" },
  { to: "/about", label: "ABOUT" },
  { to: "/merch", label: "MERCH" },
  { to: "/sponsors", label: "SPONSORS" },
  { to: "/gallery", label: "GALLERY" },
  { to: "/contact", label: "CONTACT" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <nav data-testid="main-navbar" className="sticky top-0 z-50">
      {/* Top gold line */}
      <div className="h-[3px] gold-accent" />

      {/* Main bar */}
      <div className="bg-[#0D0D0D]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-3">
            {/* Logo + ON AIR */}
            <div className="flex items-center gap-4">
              <Link to="/" data-testid="nav-logo-link" className="flex items-center group">
                <img src={PWC_LOGO} alt="PWC" className="h-11 w-auto transition-transform group-hover:scale-105" />
              </Link>
              <div className="hidden sm:block on-air">LIVE</div>
            </div>

            {/* Desktop nav */}
            <div className="hidden md:flex items-center gap-0">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`nav-link-${link.label.toLowerCase()}`}
                  className={`font-heading text-xs tracking-[0.15em] px-4 py-2 transition-all border-b-2 ${
                    location.pathname === link.to
                      ? "text-[#B09030] border-[#B09030]"
                      : "text-[#E8DFC8]/60 border-transparent hover:text-[#E8DFC8] hover:border-[#E8DFC8]/30"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Mobile hamburger */}
            <button
              data-testid="mobile-menu-toggle"
              className="md:hidden p-2 text-[#E8DFC8]"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>

          {/* Mobile menu */}
          {mobileOpen && (
            <div data-testid="mobile-menu" className="md:hidden pb-5 border-t border-[#B09030]/20 pt-3">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                  className={`block py-3 font-heading text-base tracking-wider ${
                    location.pathname === link.to ? "text-[#B09030]" : "text-[#E8DFC8]/70"
                  }`}
                  onClick={() => setMobileOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Bottom gold line */}
      <div className="h-[3px] gold-accent" />
    </nav>
  );
}
